import React from "react";
import useObjectInput from "../../../../../hooks/useObjectInput";

const allowedKeys = [
  "Backspace",
  "Enter",
  "Tab",
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "-",
];

const GOIFieldInteger = ({ disabled, value, inputData }) => {
  const { onInputValueChange } = useObjectInput();

  const { placeholder } = inputData.options;

  const handleValueChange = (e) => {
    let inputValue = e.target.value;
    onInputValueChange(inputData.id, inputValue);
  };

  const handleKeyPress = (e) => {
    if (!allowedKeys.includes(e.key) && isNaN(parseInt(e.key, 10))) {
      e.preventDefault();
    }
  };

  return (
    <input
      type="number"
      defaultValue={value}
      placeholder={placeholder}
      onChange={handleValueChange}
      disabled={disabled}
      onKeyDown={handleKeyPress}
    />
  );
};

export default GOIFieldInteger;
